import { PaletteColorOptions } from "@mui/material";

const mainColor = "#E22D3F";

export const errorLight: PaletteColorOptions = {
  main: mainColor,
  light: "#FF495B",
  dark: "#CC0317",
  contrastText: "#FFF",
};
